/** Section titles (Agents, Projects, Recent Chats): Regular 14px. */
export const sidebarSectionHeaderLabelClass =
  'font-poppins text-sm font-normal leading-heading tracking-normal text-grey-400';

/**
 * Normal chat titles under Agents / Projects / Recent Chats.
 * Color is applied at the call site via useTheme (light #3D3D3D · dark Grey/300).
 */
export const sidebarSectionItemLabelClass =
  'font-poppins text-sm font-normal leading-heading tracking-normal';

/** Agent and project names: Medium 14px. Conversations stay Regular 14px. */
export const sidebarSectionEntityLabelClass =
  'font-poppins text-sm font-medium leading-normal tracking-normal';
